import createReducer from '../../middlewares/api/createReducer'
import { GET_YEARS } from './actions'

export default createReducer(GET_YEARS, [])
